import React, { useMemo } from 'react'

type TProps = {
  timerRef: React.RefObject<HTMLElement>
  defaultValue: string
}

export const TimerText: React.FC<TProps> = ({ defaultValue, timerRef }) => {
  const timerRefHasAttribute = useMemo(() => {
    return timerRef?.current?.hasAttribute('data-value')
  }, [timerRef])
  const value = (
    <>
      {defaultValue.split(':')[0]}
      <span>:</span>
      {defaultValue.split(':')[1]}
    </>
  )
  return !timerRefHasAttribute && value
}
